import React from "react";
import Header from "../header/Header";
import { Outlet } from "react-router-dom";
import FooterPage from "../footer/FooterPage";

const Layout = () => {
  return (
    <>
      <Header />
      <Outlet />
      <FooterPage />
    </>
  );
};

export default Layout;
